import {
  Checkbox,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";
import { Controller } from "react-hook-form";
import { useTable } from "react-table";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles((theme) => ({
  table: {
    maxHeight: "288px",
    overflow: "auto",
    postion: "relative",
    "&.error": {
      borderColor: "#f44336",
    },
  },
  tableHeader: {
    position: "fixed",
    top: "0",
  },
  tableCell: {
    paddingTop: 3,
    paddingBottom: 3,
  },
}));

// const IndeterminateCheckbox = React.forwardRef(
//   ({ indeterminate, ...rest }, ref) => {
//     const defaultRef = React.useRef();
//     const resolvedRef = ref || defaultRef;

//     React.useEffect(() => {
//       resolvedRef.current.indeterminate = indeterminate;
//     }, [resolvedRef, indeterminate]);

//     return <CustomCheckbox type="checkbox" ref={resolvedRef} {...rest} />;
//   }
// );

export default function PeriodTable(props) {
  const {
    periodList,
    control,
    // register,
    periodId,
    selectedRows,
    // setValue,
    // getValues,
  } = props;
  const classes = useStyles();

  const [selectedRowId] = React.useState(null);
  const selectedRowIds = [];
  if (selectedRowId) {
    selectedRowIds.push(selectedRowId);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Period Name",
        accessor: "period",
      },
      {
        Header: "Parent Period Name",
        accessor: "year",
      },
      {
        Header: "Slug",
        accessor: "slug",
      },
    ],
    []
  );

  const { getTableProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: periodList,
      initialState: {
        selectedRowIds: selectedRows,
      },
    },
    (hooks) => {
      hooks.visibleColumns.push((columns) => [...columns]);
    }
  );

  return (
    <Controller
      control={control}
      defaultValue={periodId}
      name="periodId"
      rules={{ required: "Required" }}
      render={({
        field: { onChange, value, ...rest },
        fieldState: { error },
      }) => (
        <>
          <Paper
            variant="outlined"
            className={`${classes.table} ${error && "error"}`}
          >
            <Table {...getTableProps()}>
              <TableHead>
                {headerGroups.map((headerGroup) => (
                  <TableRow {...headerGroup.getHeaderGroupProps()}>
                    <TableCell />
                    {headerGroup.headers.map((column) => (
                      <TableCell
                        {...column.getHeaderProps()}
                        className={classes.tableCell}
                      >
                        {column.render("Header")}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableHead>
              <TableBody>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <TableRow {...row.getRowProps()}>
                      <TableCell className={classes.tableCell}>
                        <Checkbox
                          onChange={() => {
                            onChange(row.original.id);
                          }}
                          checked={value === row.original.id}
                          inputProps={{ type: "radio" }}
                          value={row.original.id}
                          color="primary"
                          size="big"
                        />
                      </TableCell>
                      {row.cells.map((cell) => {
                        return (
                          <TableCell
                            {...cell.getCellProps()}
                            className={classes.tableCell}
                          >
                            {cell.render("Cell")}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Paper>
          {error ? (
            <FormHelperText
              error={true}
              style={{ margin: "4px 0", fontSize: "14px" }}
            >
              {error.message}
            </FormHelperText>
          ) : (
            ""
          )}
        </>
      )}
    />
  );
}
